import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { stashAuthTokensFromUrl } from './services/authHub'
import { stashJoinCodeFromUrl } from './services/joinLink'
import { startAnalytics } from './services/analytics'

// Move Auth Hub sign-in tokens and partner session codes out of the URL
// before anything can record them, then arm the consent-aware analytics rail.
// GA4 loads only if the user has already said yes (first-visit notice or the
// Data & Privacy page).
stashAuthTokensFromUrl()
stashJoinCodeFromUrl()
startAnalytics()

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
